import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";

import Layout from "components/Layout";
import { CALIBRATE_COLORS, CALIBRATE_RADIUS_MD } from "components/hoc/Theme";
import { managementTheme } from "components/management/managementTheme";
import {
  SHELL_MAIN_CHROME_PADDING_PX,
  VIEWPORT_COMPACT_MAX_MEDIA,
} from "config";

interface SecureExchangeShellProps {
  /** The browser tab title. */
  title: string;
  breadcrumbs?: ReactNode;
  header: ReactNode;
  /** The white panel under the header; left out, the page ends at the header. */
  children?: ReactNode;
}

/** Every Secure Exchange page: breadcrumbs, the header card and one white panel on
 * the grey chrome. The panel fills the height and scrolls its own content. */
export default function SecureExchangeShell({
  title,
  breadcrumbs,
  header,
  children,
}: SecureExchangeShellProps) {
  return (
    <Layout title={title} content={title} noScroll>
      <ThemeProvider theme={managementTheme}>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            alignSelf: "stretch",
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            bgcolor: CALIBRATE_COLORS.chromeBackground,
            p: { xs: 1.5, sm: `${SHELL_MAIN_CHROME_PADDING_PX}px` },
            [VIEWPORT_COMPACT_MAX_MEDIA]: { p: 1.5 },
            boxSizing: "border-box",
          }}
        >
          {breadcrumbs}
          {header}
          {children ? (
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                bgcolor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: `${CALIBRATE_RADIUS_MD}px`,
              }}
            >
              {children}
            </Box>
          ) : null}
        </Box>
      </ThemeProvider>
    </Layout>
  );
}
